// Intercept ww-buy — go to product page instead of direct checkout
document.addEventListener('click', function(e) {
  var t = e.target;
  if (t && (t.id === 'ww-buy' || (t.closest && t.closest('#ww-buy')))) {
    e.stopImmediatePropagation();
    e.preventDefault();
    window.location.href = '/products/dental-oral-supplement-powder';
  }
}, true);
